import AuthRepository from './repositories/AuthRepository';
import AccountRepository from './repositories/AccountRepository';
import AreaRepository from './repositories/AreaRepository';
import BillingAddressRepository from './repositories/BillingAddressRepository';
import CartRepository from './repositories/CartRepository';
import ProductRepository from './repositories/ProductRepository';
import ShippingAddressRepository from './repositories/ShippingAddressRepository';
import BlogRepository from './repositories/BlogRepository';
import ProductCategoryRepository from './repositories/ProductCategoryRepository';
import PageRepository from './repositories/PageRepository';
import BrandRepository from './repositories/BrandRepository';
import SettingRepository from './repositories/SettingRepository';
import WishlistRepository from './repositories/WishlistRepository';
import OrderRepository from './repositories/OrderRepository';
import PaymentRepository from './repositories/PaymentRepository';
import MenuRepository from './repositories/MenuRepository';
import DistributorRepository from './repositories/DistributorRepository';
import JobCareerRepository from './repositories/JobCareerRepository';

const repositories = {
  account: AccountRepository,
  auth: AuthRepository,
  area: AreaRepository,
  blog: BlogRepository,
  billingAddress: BillingAddressRepository,
  brand: BrandRepository,
  cart: CartRepository,
  distributor: DistributorRepository,
  jobCareer: JobCareerRepository,
  menu: MenuRepository,
  order: OrderRepository,
  page: PageRepository,
  payment: PaymentRepository,
  product: ProductRepository,
  productCategory: ProductCategoryRepository,
  setting: SettingRepository,
  shippingAddress: ShippingAddressRepository,
  wishlist: WishlistRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
